import { LitElement, html, css } from 'lit'

class PlayIcon extends LitElement {
  static styles = css`
  :host {
    display: block;
    width: var(--icon-width, 1em);
    height: var(--icon-height, auto);
    position: relative;
    top: var(--icon-offset, 2px);
  }
  svg {
    stroke: var(--icon-stroke-color, currentColor);
    stroke-width: var(--icon-stroke-width, 1.5);
    fill: none;
    width: 100%;
    height: auto;
  }
`
  render() {
    return html`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        part="svg"
      >
        <path
          d="M16.6582 9.28663C18.098 10.1865 18.8178 10.6364 19.0647 11.2124C19.2803 11.7155 19.2803 12.285 19.0647 12.788C18.8178 13.3641 18.098 13.814 16.6582 14.7138L9.896 18.9402C8.29805 19.9389 7.49907 20.4383 6.83973 20.3853C6.26501 20.3391 5.73818 20.0471 5.3944 19.5842C5 19.0532 5 18.111 5 16.2266V7.77381C5 5.88944 5 4.94725 5.3944 4.41622C5.73818 3.95334 6.26501 3.66135 6.83973 3.61515C7.49907 3.56214 8.29805 4.0615 9.896 5.06022L16.6582 9.28663Z"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>
    `
  }
}
customElements.define('play-icon', PlayIcon)
